import { createStore } from 'easy-peasy';

import model from './model';

export default createStore(model);
